import React from "react";
import { DesktopProjectEntry } from "./contentCards/desktopProjectEntry";
import { projects } from "../../data";

const DesktopProjects = () => {
  return (
    <div className="text-white">
      <div
        style={{
          fontSize: "3em",
          fontWeight: "300",
          lineHeight: "1.25",
        }}
        className="py-2"
      >
        Projects
      </div>
      {projects.map((project) => (
        <DesktopProjectEntry key={project.id} project={project} />
      ))}
    </div>
  );
};

export default DesktopProjects;
